// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Col, SchemaForm } from "@components";
import uiSchema from "./ui-schema";

type Props = $Exact<{
  onDismissHandler: () => *,
  onSubmit: (form: Object) => void,
  schema: ?Object,
  disabledButton: boolean,
  ...PropsFromLocalize,
}>;

export class AddDocumentModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  get schema() {
    return {
      type: "object",
      $id: "urn:jsonschema:eu:firstcare:api:v1:dto:employee:admin:activity:EmployeeFileDTO",
      required: ["file", "file_type"],
      properties: {
        file: {
          type: "string",
          format: "data-url",
          title: "Single file",
        },
        file_type: {
          type: "string",
          title: "File Type",
          oneOf: [
            { title: "Appraisal form", const: "APPRAISAL_FORM" },
            { title: "File note", const: "FILE_NOTE" },
            { title: "Fit note", const: "FIT_NOTE" },
            { title: "Interview form", const: "INTERVIEW_FORM" },
            { title: "Letter", const: "LETTER" },
            { title: "Other", const: "OTHER" },
          ],
        },
      },
    };
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader
          toggle={this.props.onDismissHandler}
          className="d-flex justify-content-between"
        >
          {this.props.t("ADD_DOCUMENT")}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            schema={this.schema}
            onSubmit={this.handleSubmit}
            uiSchema={uiSchema}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon="add_box"
            disabled={this.props.disabledButton}
            onClick={this.submitForm}
          >
            {this.props.t("ADD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddDocumentModal);
